'use strict';
import React from 'react';
import classNames from 'classnames';

/**
 * Table component.
 * Defines styling for a table with fixed header, scrollable body, sort elements.
 * Default scroll size is calculated for more than 10 table rows.
 * For extremely data dense tables, the Table--large modifier provides additional padding for all content.
 *
 * Due to the fixed table header, content of Table-headerLink will not wrap by default.
 * The modifier class Table--tallHeader is available for tables to increase the height of the table header to allow two rows of header text.
 * Text must be manually wrapped with a <br> tag.
 *
 * @extends {React.Component}
 * @property {Boolean} isTallHeader Increase the height of the table header to allow two rows of header text.
 * @property {Boolean} isTableLarge Renders additional padding for all content of the table.
 */
class Table extends React.Component {

  /**
   * @return {String} Component CSS classname.
   */
  getClassName (isTallHeader, isTableLarge, scrollable) {
    return classNames({
      'Table': true,
      'Table--tallHeader': isTallHeader,
      'Table--large': isTableLarge,
      'Table--scrollable': scrollable
    });
  }

  /**
   * Render the component
   *
   * @return {JSX} JSX component markup.
   **/
  render () {
    const { children, scrollable, isTableLarge, isTallHeader, ...otherProps } = this.props;

    return (
      <div className={this.getClassName(isTallHeader, isTableLarge, scrollable)}>
        <div className="Table-headBackground"></div>
        <div className="Table-scroll">
          <table {...otherProps}>
            { children }
          </table>
        </div>
      </div>
    );
  }
}

/**
 * @prop {propTypes} propTypes - required attributes for the Table component
 */
Table.propTypes = {
  isTableLarge: React.PropTypes.bool,
  isTallHeader: React.PropTypes.bool,
  scrollable: React.PropTypes.bool
};

Table.defaultProps = {
  isTableLarge: false,
  isTallHeader: false,
  scrollable: false
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/table/table.jsx